<template>
  <div class="profile-wrapper select-scroll">
    <div class="profile-page-1">
      <div class="profile-information-wrapper select-scroll pt-10">
        <div class="row">
          <div class="col-md-1 col common-back-arrow">
            <i class="fa fa-angle-left pl-5" style="font-size: 32px; cursor: pointer;" @click="goBack()"></i>
          </div>
          <div class="col-md-12 col-12 p-0">
            <div class="pl-0">
              <h3 v-translate:rsb_agreement="lang" class="text-center">
                Agreement
              </h3>
              <div id="agreement" v-if="agreement" class="pl-40 pr-40 pt-20">
                <div class="card-body p-0">
                  <div
                    :key="`${selectedConsentID}_agreement_html`"
                    v-translate:dynamic_string="{
                      key: `${selectedConsentID}_agreement_html`,
                      val: lang,
                      html: agreement
                    }"
                    v-html="agreement"
                  ></div>
                </div>
              </div>
              <div v-else>
                <div class="card-body">
                  <p class="mt-30" v-translate:loading="lang">Loading...</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import nprogress from "nprogress";
import { mapGetters } from "vuex";
import { Consent, Bitrise, ParticipantPortal } from "@/components/services/participant-service";

export default {
  name: "agreement",
  props: ["selectedConsentID", "backButtonClicked"],
  data() {
    return {
      bitrise: new Bitrise(),
      consent: new Consent(),
      portal: new ParticipantPortal(),
      agreement: "",
      pid: "",
      globalElement: null
    };
  },
  mounted() {
    this.getAgreementData();
  },
  computed: {
    ...mapGetters(["participant", "token", "getParticipantsPortalBitriseData"]),
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    }
  },
  methods: {
    getAgreementData() {
      nprogress.start();
      if (this.consent.bitrise.isAggrementAvailable(this.selectedConsentID)) {
        this.consent
          .getDocumentAndSignHtml(this.selectedConsentID)
          .then(html => {
            nprogress.done();
            this.agreement = html.body.innerHTML;
          })
          .catch(() => {
            nprogress.done();
          });
      }
    },
    goBack() {
      this.$emit("backButtonClicked", "false");
    }
  }
};
</script>
<style scoped>
.agreement-structure {
  width: 100%;
  height: 717px;
  border: none;
  background-color: #fff;
}
</style>
